import { CryptoWithdrawStatus } from '@/entities/cryptoWithdraw'
import { IconStatus } from '@/shared/utils'
import { BalanceAction, FinanceStatus } from './types'

export type ButtonStatus = 'pending' | 'inProgress' | 'completed' | 'canceled'

export const CryptoWithdrawStatusTitles: Record<CryptoWithdrawStatus, string> = {
  [CryptoWithdrawStatus.Created]: 'Создан',
  [CryptoWithdrawStatus.InProgress]: 'В обработке',
  [CryptoWithdrawStatus.Completed]: 'Завершен',
  [CryptoWithdrawStatus.Failed]: 'Отменен',
}

export const CryptoWithdrawStatusIcons: Record<CryptoWithdrawStatus, IconStatus> = {
  [CryptoWithdrawStatus.Created]: 'green',
  [CryptoWithdrawStatus.Completed]: 'green',
  [CryptoWithdrawStatus.InProgress]: 'yellow',
  [CryptoWithdrawStatus.Failed]: 'red',
}

export const CryptoWithdrawStatusLabel: Record<CryptoWithdrawStatus, ButtonStatus> = {
  [CryptoWithdrawStatus.Completed]: 'completed',
  [CryptoWithdrawStatus.Created]: 'pending',
  [CryptoWithdrawStatus.InProgress]: 'inProgress',
  [CryptoWithdrawStatus.Failed]: 'canceled',
}

export const BalanceActionTitles: Record<BalanceAction, string> = {
  [BalanceAction.PayInTraderCommission]: 'Комиссия трейдера (входящий платеж)',
  [BalanceAction.PayInMerchantCommission]: 'Комиссия мерчанта (входящий платеж)',
  [BalanceAction.PayOutTraderCommission]: 'Комиссия трейдера (исходящий платеж)',
  [BalanceAction.PayOutMerchantCommission]: 'Комиссия мерчанта (исходящий платеж)',

  [BalanceAction.PayInTraderReferralCommission]: 'Реферальная комиссия трейдера (входящий)',
  [BalanceAction.PayInMerchantReferralCommission]: 'Реферальная комиссия мерчанта (входящий)',
  [BalanceAction.PayOutTraderReferralCommission]: 'Реферальная комиссия трейдера (исходящий)',
  [BalanceAction.PayOutMerchantReferralCommission]: 'Реферальная комиссия мерчанта (исходящий)',

  [BalanceAction.Deposit]: 'Пополнение баланса',
  [BalanceAction.CryptoWithdraw]: 'Крипто-вывод',
  [BalanceAction.CryptoDeposit]: 'Крипто-депозит',
  [BalanceAction.AdminChange]: 'Изменение баланса админом',

  [BalanceAction.MerchantTopupConfirmed]: 'Пополнение мерчанта подтверждено',
  [BalanceAction.TopupCommission]: 'Комиссия за пополнение',

  [BalanceAction.TraderTopupCreated]: 'Создано пополнение трейдера',
  [BalanceAction.TraderTopupPaid]: 'Пополнение трейдера успешно',
  [BalanceAction.TraderTopupTimeout]: 'Пополнение трейдера отменено по таймауту',
  [BalanceAction.TraderTopupCancelledByPayer]: 'Пополнение трейдера отменено плательщиком',

  [BalanceAction.WithdrawCreated]: 'Создана заявка на фиатный вывод',
  [BalanceAction.WithdrawFailed]: 'Фиатный вывод зафейлился',
  [BalanceAction.WithdrawCancelledByAdmin]: 'Фиатный вывод отменен админом',
  [BalanceAction.WithdrawPaid]: 'Фиатный вывод совершен',
  [BalanceAction.WithdrawPartiallyPaid]: 'Фиатный вывод частично совершен',
  [BalanceAction.WithdrawCommission]: 'Комиссия за фиатный вывод',

  [BalanceAction.BalanceTransfer]: 'Перевод между балансами',
}

export const FINANCE_STATUS_MAP: Record<number, FinanceStatus | undefined> = {
  0: undefined,
  1: FinanceStatus.All,
  2: FinanceStatus.Withdraw,
  3: FinanceStatus.Deposit,
}
